import React, { Component } from "react";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Dropdown
} from "reactstrap";
import { Link } from "react-router-dom";
import AuthService from "../../components/AuthService";

class HeaderDropdown extends Component {
  constructor(props) {
    super(props);
    this.Auth = new AuthService();
    this.toggle = this.toggle.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      dropdownOpen: false
    };
  }

  handleClick() {
    this.Auth.logout();
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  dropAccnt() {
    let name;
    if (this.Auth.loggedIn()) {
      name = this.Auth.getProfile().sub;
      //console.log(this.Auth.getProfile());
    }
    return (
      <Dropdown nav isOpen={this.state.dropdownOpen} toggle={this.toggle}>
        <DropdownToggle nav>{name}</DropdownToggle>
        <DropdownMenu right>
          <DropdownItem header tag="div" className="text-center">
            <strong>Settings</strong>
          </DropdownItem>
          <DropdownItem>
            <i className="fa fa-user" /> Profile
          </DropdownItem>
          <DropdownItem>
            <i className="fa fa-wrench" /> Settings
          </DropdownItem>
          <DropdownItem divider />
          <Link to="/login">
            <DropdownItem onClick={this.handleClick}>
              <i className="fa fa-lock" /> Se déconnecter
            </DropdownItem>
          </Link>
        </DropdownMenu>
      </Dropdown>
    );
  }

  render() {
    return this.dropAccnt();
  }
}

export default HeaderDropdown;



// WEBPACK FOOTER //
// ./src/components/Header/HeaderDropdown.js